import { Marker, Tooltip } from "react-leaflet";
import L from "leaflet";

const icon = L.divIcon({
  className: "",
  iconSize: [22, 22],
  iconAnchor: [11, 11],
  html: '<div class="atlas-reported"><span>!</span></div>',
});

// Media-reported floods / landslides (unverified) — shown so gaps in sensor coverage are visible.
export const ReportedLayer = ({ events = [] }) =>
  events.map((e) => (
    <Marker key={e.uid} position={[e.lat, e.lon]} icon={icon}
      eventHandlers={{ click: () => e.link && window.open(e.link, "_blank", "noopener") }}>
      <Tooltip direction="top" offset={[0, -10]} className="atlas-tip" opacity={1}>
        <b>REPORTED (unverified)</b>
        <br />
        {e.title}
        <br />
        <span className="atlas-tip-muted">
          {e.provider} · located by country · first report {new Date(e.observed_at).toUTCString().slice(5, 22)} UTC
        </span>
      </Tooltip>
    </Marker>
  ));
